// Libararies
import React from 'react';

// Supermove
import {DataLoader, Styled} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useQuery} from '@supermove/hooks';
import {ProjectModel} from '@supermove/models';
import {colors} from '@supermove/styles';

// Shared
import ProjectAttachmentsPanel from '@shared/modules/Project/components/Attachment/ProjectAttachmentsPanel';

const Container = Styled.View`
  flex: 1;
  padding: 16px;
  background-color: ${colors.gray.background};
`;

const ProjectAttachmentsWidget = ({projectUuid}: {projectUuid: string}) => {
  const {data, loading} = useQuery<{project: ProjectModel}>(ProjectAttachmentsWidget.query, {
    fetchPolicy: 'cache-and-network',
    variables: {projectUuid},
  });

  return (
    <Container>
      <DataLoader loading={loading} data={data}>
        {({loadedData}) => {
          return (
            <ProjectAttachmentsPanel
              project={loadedData.project}
              containerStyle={{flex: 1}}
              isWidget
            />
          );
        }}
      </DataLoader>
    </Container>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectAttachmentsWidget.query = gql`
  ${ProjectAttachmentsPanel.fragment}
  query ProjectAttachmentsWidget($projectUuid: String!) {
    ${gql.query}
    project(uuid: $projectUuid) {
      id
      ...ProjectAttachmentsPanel
    }
  }
`;

export default ProjectAttachmentsWidget;
